import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledStack = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: `repeat(2, 1fr) 25px`,
  alignItems: "center",
  borderBottom: "1px solid",
  borderRight: "1px solid",
  borderLeft: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  backgroundColor: theme.palette.hubColors.white,
  ":hover": {
    backgroundColor: theme.palette.hubColors.greyLightest,
  },
  ".MuiInputBase-root, input": {
    borderRadius: 0,
    backgroundColor: "transparent !important",
  },
  fieldset: {
    borderWidth: 0.5,
  },
}));

export const StyledCell = styled(Stack)(({ theme }) => ({
  height: "100%",
  width: "100%",
  borderRight: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  alignItems: "center",
  justifyContent: "center",
}));
